// extracted by css-extract-rspack-plugin
export default {"widgetGallerySlidesItem":"widget-gallery-slides-item--bQnpk82J_crKk_MC","widgetGallerySwitcherContainer":"widget-gallery-switcher-container--S236j7RjAFojNgnT"};